<div class="filter-chips-component">
  @if (getFilterChipCount() > 0) {
    <span class="filter-applied-text"> Filters Applied: </span>
  }
  <!-- Render search chip -->
  @if (
    activeChipFilters?.searchText &&
    activeChipFilters?.searchText != undefined &&
    activeChipFilters?.searchText != ""
  ) {
    <geaui-chip-v3
      postIcon="close"
      size="small"
      [readOnly]="false"
      [active]="false"
      severity="default"
      (toggled)="
        removeChip({
          chipKey: 'searchText',
          chipValue: activeChipFilters?.searchText,
        })
      "
    >
      "{{ globalSearch }}": "{{ activeChipFilters?.searchText }}"
    </geaui-chip-v3>
  }
  <!-- Render filter chips -->
  @if (activeChipFilters?.filters) {
    @for (key of getFilterKeys(); track key) {
      @if (activeChipFilters?.filters[key]?.filter?.length) {
        @for (val of activeChipFilters?.filters[key].filter; track val) {
          <geaui-chip-v3
            postIcon="close"
            size="small"
            [readOnly]="false"
            [active]="false"
            severity="default"
            (toggled)="removeChip({ chipKey: key, chipValue: val })"
          >
            {{ getChipFilterName(key) }}:
            {{ getChipDisplayValueName(key, val) }}
          </geaui-chip-v3>
        }
      }
      @if (
        activeChipFilters?.filters[key]?.sort &&
        activeChipFilters?.filters[key].sort !== ""
      ) {
        <geaui-chip-v3
          postIcon="close"
          size="small"
          [readOnly]="false"
          [active]="false"
          severity="default"
          (toggled)="
            removeChip({
              chipKey: key,
              chipValue: activeChipFilters?.filters[key]?.sort,
            })
          "
        >
          {{ getChipFilterName(key) }}: Sorted [{{
            activeChipFilters?.filters[key].sort
          }}]
        </geaui-chip-v3>
      }
    }
    <!-- Clear All -->
    @if (getFilterChipCount() >= 2) {
      <geaui-chip-v3
        postIcon="close"
        size="small"
        [readOnly]="false"
        [active]="true"
        (toggled)="removeChip({ chipKey: 'clearAll', chipValue: null })"
      >
        Clear All
      </geaui-chip-v3>
    }
  }
</div>
